import { useMemo, useState } from 'react'

/**
 * The Pagination' custom hook.
 */
export const usePagination = ({ data = [], initialPage = 0, initialRowsPerPage = 5 } = {}) => {
  const [page, setPage] = useState(initialPage)
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage)

  const handlePageChange = (_, newPage) => {
    setPage(newPage)
  }

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event?.target?.value)
    setPage(0)
  }

  const handleCurrentPageRecords = () => {
    return data.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)
  }

  const totalPages = useMemo(() => {
    return Math.floor(data?.length / rowsPerPage) + (data?.length % rowsPerPage !== 0 ? 1 : 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const records = useMemo(() => {
    return page === totalPages ? handleCurrentPageRecords().length : rowsPerPage
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, data])

  return {
    page,
    records,
    rowsPerPage,
    totalPages,
    onChangePage: handlePageChange,
    onChangeRowsPerPage: handleRowsPerPageChange,
    onGetCurrentPage: handleCurrentPageRecords,
    setPage
  }
}

export default usePagination
